export default function Account() {
  return (
    <h1>Mi cuenta :)</h1>
  )
}
